import { memo } from 'react';
import { MultiToggleGroup } from './ui/multi-toggle-group';
import { CARD_SEARCH_VARIANTS } from '../utils/cardPrintVariant';

export interface VariantFilterProps {
  selected: string[];
  /** Called with the toggled variant value — parent handles add/remove. */
  onChange: (value: string) => void;
  label?: string;
  disabled?: boolean;
}

export const VariantFilter = memo(function VariantFilter({
  selected,
  onChange,
  label = 'Variant',
  disabled = false,
}: VariantFilterProps) {
  return (
    <MultiToggleGroup
      label={label}
      options={CARD_SEARCH_VARIANTS.map((v) => ({ value: v.value, label: v.label }))}
      selected={selected}
      onChange={onChange}
      disabled={disabled}
      wrap
    />
  );
});
